import {
  observable,
  action,
  toJS
} from 'mobx';
import {
  message,
} from 'antd';
import base from '../../tool/base';
import util from '../../util/index';

const {
  catchApiError,
  getAccessToken
} = util;

const initState = {
  pagination: {
    pageNum: 1,
    pageSize: 10,
  },
  loadingEcode: true,
  searchValue: {
    title: ''
  },
  ecodeDates: [],
  ecodeDatesCount: 0,
  loadingOrder: false,
  detail: {},
  temporaryAuthLoading: false,
}

export class EcodeOrderStore {
  constructor(routing) {
    this.routing = routing;
  }

  @observable pagination = initState.pagination;
  @observable searchValue = initState.searchValue;
  @observable ecodeDates = initState.ecodeDates;
  @observable loadingEcode = initState.loadingEcode;
  @observable ecodeDatesCount = initState.ecodeDatesCount;
  @observable loadingOrder = initState.loadingOrder;
  @observable detail = initState.detail;
  @observable temporaryAuthLoading = initState.temporaryAuthLoading;
  @observable devAuthLoadingIds = [];
  
  @action
  setState = params => {
    Object.keys(params).map(key => {
      this[key] = params[key]
    })
  }

  @action
  setSearch = params => {
    this.searchValue = {
      ...this.searchValue,
      ...params
    }
  }

  @action
  clearSearch = () => {
    this.searchValue = initState.searchValue;
  }

  @action
  setPagination = (pageNum, pageSize) => {
    this.pagination = {
      pageNum,
      pageSize
    }
    this.getApplyList({pageNum, pageSize});
  }

  @action
  temporaryAuth = async (params, callback) => {  //申请开发权限
    this.temporaryAuthLoading = true;
    const logParams = {
      ...params,
      access_token: getAccessToken(),
    };
    base.callApi('/v5/apply/temporaryAuth', 'POST', logParams, 'json', 'text').then((data) => {
      this.temporaryAuthLoading = false;
      if (data.status) {
        message.success('申请成功');
        callback();
      } else {
        message.error(data.msg || '申请失败');
      }
    }).catch(() => {
      message.error('申请失败');
    });
  }

  @action
  getDevAuth = async (appId, params, callback) => {  //申请开发权限
    this.devAuthLoadingIds = [
      ...this.devAuthLoadingIds,
      appId,
    ];
    const logParams = {
      ...params,
      appId,
      access_token: getAccessToken(),
    };
    base.callApi('/v5/apply/getDevAuth', 'POST', logParams, 'json', 'text').then((data) => {
      this.temporaryAuthLoading = false;
      if (data.status) {
        callback(data.data);
      } else {
        message.error(data.msg || '查询失败');
      }
    }).catch(() => {
      message.error('查询失败');
    }).finally(() => {
      this.devAuthLoadingIds = this.devAuthLoadingIds.filter(id => id !== appId);
    });
  }
  
  @action
  getApplyList = (params) => {
    this.loadingOrder = true;
    params = params ? params : this.pagination;
    let _params = {
      ...params,
      title: this.searchValue.title,
      access_token: getAccessToken(),
      ...this.searchValue,
    };
    if (_params.applyDateString && _params.applyDateString.length === 2) {
      _params = {
        ..._params,
        subDate: _params.applyDateString[0],
        endDate: _params.applyDateString[1],
      }
    }
    delete _params.applyDate;
    delete _params.applyDateString;
    return new Promise(resolve => {
      base.callApi('/v5/apply/ecodeList', 'GET', _params, 'json', 'text').then((data) => catchApiError(data, this.routing)).then((data) => {
        if (data.status) {
          this.ecodeDates = data.list;
          this.ecodeDatesCount = data.count;
        } else {
          message.error(data.msg);
        }
        this.loadingOrder = false;
        // this.loadingEcode = false;
        resolve(data);
      });
    });
  }
}


// WEBPACK FOOTER //
// ./src/stores/order/EcodeOrderStore.js